<template>
  <div>
    <order-list/>
  </div>
</template>

<script>
import OrderList from '@/components/common/OrderList'

export default {
  name: 'orders-view',
  components: {
    OrderList
  }
}
</script>
